module.exports = __webpack_public_path__ + "img/folder_yellow.db1c50e9.svg";